import React, { useState } from "react";
import styles from "./Projects.module.css";
import projectsData from "../../data/projects.json";
import ProjectCard from "./ProjectCard";
import SectionIntro from "../common/SectionIntro";

const projectCategories = [
  { id: "featured", label: "Featured" },
  { id: "all", label: "All" },
  { id: "fullstack", label: "Full-stack" },
  { id: "interactive", label: "3D & interactive" },
];

const featuredTitles = [
  "Draw-On",
  "Penwell",
  "Presents.Chat",
  "Chatify - AI",
  "Meesho",
  "Naano",
  "Gallefied",
  "Moovify",
  "Trackiii",
];

const categorizeProject = (project) => {
  const t = project.title.toLowerCase();
  const s = project.skills.join(" ").toLowerCase();
  if (t === "penwell" || t.includes("chat") || s.includes("open ai") || s.includes("gemini"))
    return "featured";
  if (
    t === "gallefied" ||
    s.includes("three") ||
    t.includes("dice") ||
    t.includes("royale") ||
    t.includes("tic tac") ||
    t.includes("moovify")
  )
    return "interactive";
  return "fullstack";
};

const Projects = () => {
  const [activeTab, setActiveTab] = useState("featured");

  const filteredProjects = projectsData.filter((project) => {
    if (activeTab === "all") return true;
    if (activeTab === "featured") return featuredTitles.includes(project.title);
    if (activeTab === "fullstack")
      return categorizeProject(project) === "fullstack" || featuredTitles.includes(project.title);
    if (activeTab === "interactive") return categorizeProject(project) === "interactive";
    return true;
  });

  return (
    <section className={styles.container} id="projects">
      <SectionIntro
        index="03"
        label="Selected work"
        title="Things I shipped, and what they had to do."
        lede="Nine of the twenty are the ones I would show first, including the SVG animation library I published on npm. The rest are older builds kept around on purpose."
      >
        <div className={styles.tools}>
          <div className={styles.tabs} role="tablist" aria-label="Project categories">
            {projectCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                role="tab"
                aria-selected={activeTab === cat.id}
                onClick={() => setActiveTab(cat.id)}
                className={`${styles.tabBtn} ${activeTab === cat.id ? styles.tabActive : ""}`}
              >
                {cat.label}
              </button>
            ))}
          </div>
          <span className={styles.count}>
            {filteredProjects.length} of {projectsData.length}
          </span>
        </div>
      </SectionIntro>

      <div className={styles.grid}>
        {filteredProjects.map((project, index) => (
          <ProjectCard key={project.title || index} project={project} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
